import * as Sentry from '@sentry/browser';
import { confirmLeave } from './constants';
import { OV_ALERT, TEXT } from '../../config/constants';
/*
 * A function to track add to cart errors
 */

export var fetchError = function fetchError(exception) {
  var _window = window,
      dispatchEvent = _window.dispatchEvent;

  if (Sentry) {
    Sentry.captureException(exception);
  }

  var event = new CustomEvent(OV_ALERT, {
    detail: TEXT.alertCX
  });
  dispatchEvent(event);
};
/*
 * A function to stop a user from leaving the page without confirmation
 */

export var onConfirmLeave = function onConfirmLeave() {
  return confirmLeave;
};
export var filterColorwaysForSwatches = function filterColorwaysForSwatches(colorways) {
  return colorways.filter(function (_ref) {
    var node = _ref.node;
    var flat = node.assets.edges.find(function (_ref2) {
      var assetNode = _ref2.node;
      return assetNode.type === 'KIT';
    });
    return flat && node.swatch !== null;
  }).map(function (_ref3) {
    var _ref3$node = _ref3.node,
        id = _ref3$node.id,
        color = _ref3$node.color,
        available = _ref3$node.available,
        swatch = _ref3$node.swatch;
    return {
      disabled: !available,
      id: swatch.id,
      image: swatch.image,
      label: color,
      value: id
    };
  });
};